import { useState, useEffect, useRef } from "react";
import { useSearchParams } from 'react-router-dom';
import { postEventConsumptionDetailsV2 } from './apiService'; 
import CustomAlert from "./CustomAlert";
import sprout_icon from './assets/sprout_icon.png';


function AddInformation() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('id') || '1234';
  const eventName = searchParams.get('eventName') || 'Diwali';

  const [activeTab, setActiveTab] = useState('individual');

  const locationRef = useRef(null);
  const [location, setLocation] = useState("");

  const [formData, setFormData] = useState({
    userName: '',
    emailId: '',
    travelMode: '',
    transportationType: '',
    startingLocation: '',
    hotelType: 'NA',
    mealPreference: 'Veg',
    eventDuration: '1 Days',
    transportationTypeOptions: [],
  });

  const travelModeMapping = {
    'Car': {
      'Diesel': 1,
      'Petrol': 2,
      'CNG': 3,
      'Electric': 4,
    },
    'Bus': {
      'Fuel-Based': 5,
      'Electric': 7,
    },
    'Train': {
      'Train': 6,
    },
    'Flight': {
      'Economy': 8,
      'Business': 13,
    },
  };
  

  const hotelTypeMapping = {
    '3-Star': 1,
    '4-Star': 2,
    '5-Star': 3,
    'NA':4,
  };

  const mealPreferenceMapping = {
    'Veg': 6,
    'Non-Veg': 7,
    'Vegan': 8,
  };

  const eventDurationMapping = {
    '1 Days': 1,
    '2 Days': 2,
  };
  useEffect(() => {
    const initializeAutocomplete = () => {
      const locationInput = locationRef.current;

      const autocomplete = new window.google.maps.places.Autocomplete(
        locationInput,
        {
          componentRestrictions: { country: "in" },
          strictBounds: false,
        }
      );

      autocomplete.setFields([
        "formatted_address",
        "geometry.location",
        "name",
        "place_id",
      ]);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
          alert("No details available for input: '" + place.name + "'");
          return;
        }
        console.log(place);
        setLocation(place.formatted_address);
        console.log("Selected place:", place.formatted_address);
        setFormData((prevFormData) => ({
          ...prevFormData,
          startingLocation: place.formatted_address,
        }));
      });
    };

    if (window.google && window.google.maps) {
      initializeAutocomplete();
    } else {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCpdevcXjKt9CVD1n8chB59MGW0d1uT2dg&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = initializeAutocomplete;
      document.head.appendChild(script);
    }
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prevState) => {
      let newFormData = { ...prevState, [name]: value };
  
      if (name === 'travelMode') {
        let options = [];
        switch (value) {
          case 'Car':
            options = ['Diesel', 'Petrol', 'CNG', 'Electric'];
            break;
          case 'Bus':
            options = ['Fuel-Based', 'Electric'];
            break;
          case 'Train':
            options = ['Train'];
            break;
          case 'Flight':
            options = ['Economy', 'Business'];
            break;
          default:
            options = [];
        }
        newFormData.transportationTypeOptions = options;
      newFormData.transportationType = options[0] || '';
      newFormData.transportationTypeId = travelModeMapping[value] ? Object.values(travelModeMapping[value])[0] : 0;
      }
  
      if (name === 'transportationType') {
        const selectedTravelMode = formData.travelMode;
      const selectedType = value;
      const selectedTypeId = travelModeMapping[selectedTravelMode][selectedType] || 0;
      newFormData.transportationTypeId = selectedTypeId;
      }
  
      return newFormData;
    });
  };
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('success');
  const handleCloseAlert = () => {
    setShowAlert(false);
    if (alertType === 'success') {
      
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Form Data : ", formData);
      const data = {
        EventId: eventId,
        UserName: formData.userName,
        UserEmail: formData.emailId,
        TravelModeId: formData.transportationTypeId || 0,
        Location: {
          location: formData.startingLocation,
          locationId: 0,
        },
        AccommodationId: hotelTypeMapping[formData.hotelType] || 0,
        StayDays: eventDurationMapping[formData.eventDuration] || 0,
        MealPreferenceId: mealPreferenceMapping[formData.mealPreference] || 0,
      };
  
      const response = await postEventConsumptionDetailsV2(data);
      console.log('Form data saved successfully:', response);
      console.log("API Data : ", data);
      setAlertMessage("Data saved successfully");
      setAlertType("success");
      setShowAlert(true);
    } catch (error) {
      console.error('Error saving form data:', error);
    }
  };
  
  
  return (
    <div>
      <style>{`
        .top-bar {
          background-color: #007272;
          padding: 12px 150px;
          color: white;
          font-family: Arial, sans-serif;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          position: fixed; 
          width: 100%;
          top: 0;
          z-index: 1000;
          box-sizing: border-box; 
        }
        .top-bar h2 {
          font-size: 16px;
          margin: 0;
        }
        .top-bar-icon {
          width: 40px;  
          height: 40px; 
          margin-right: 95px; 
          background-color:white;
          margin-left: 20px;
          margin-top: 5px;
        }
        .tab-container {
          background-color: white;
          padding: 10px 10px;
          display: flex;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
          margin-top: 38px; 
          width: 100%;
          box-sizing: border-box; 
        }

        .tab-container h2 {
          font-size: 16px;
          margin: 0;
          color: #000;
      
        }

        .form-container {
          background-color: #ffffff;
          padding: 20px;
          font-family: Arial, sans-serif;
          border-radius: 1px black;
          box-shadow: 0px 4px 6px rgba(0.2, 0, 0, 0.3);
          margin: 0px auto; 
          width: 85%; 
          max-width: 1100px; 
          box-sizing: border-box; 
          overflow-y: auto; 
        }

        .form-container h2 {
          font-size: 20px;
          margin-bottom: 20px;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: bold;
        }

        .form-group input,
        .form-group select {
          width: 100%;
          padding: 10px;
          box-sizing: border-box;
          border: 1px solid #ccc;
          border-radius: 4px;
        }
        .form-group input:focus,
        .form-group select:focus {
          outline: none; 
        }
        .form-row {
          display: flex;
          justify-content: space-between;
          gap: 20px;
        }

        .form-row .form-group {
          flex: 1;
        }

        .submit-button {
          padding: 8px 10px;
          background-color: #007272;
          color: white;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 14px;
        }

        .submit-button:hover {
          background-color: #005f5f;
        }

        /* Style for the horizontal line */
        .divider {
          width: 100%;
          height: 1px;
          background-color: #007272;
          border: black;
          margin: 0px 0; 
          box-shadow: 0px 4px 6px rgba(0.1, 0, 0, 0.3);
        }
        .event-name {
          background-color: #ffffff;
          color: #007272;
          padding: 10px 15px;
          border-radius: 5px;
          margin: -35px 0px 0; 
          text-align: right; 
          width: 100%; 
          display: flex;
          justify-content: flex-end; 
          
        
        }
      `}</style> 
      <div className="top-bar">
        
        <h2
          className={activeTab === 'individual' ? 'active' : ''}
          onClick={() => setActiveTab('individual')}
          style={{
            backgroundColor: activeTab === 'individual' ? 'white' : '#007b5e',
            color: activeTab === 'individual' ? 'black' : 'white',
            padding: '10px 10px 0px 12px', 
            cursor: 'pointer',
            marginBottom: '-12px', 
          }}
        >
          Individual
        </h2>
      </div>

      <div className="tab-container">
      <img src={sprout_icon} alt="Icon" className="top-bar-icon" />
        <h2
          className=""
          style={{
            backgroundColor: '#ffffff',
            color: 'black',
            padding: '10px 15px',
            borderRadius: '5px',
          }}
        >
          My Information
        </h2>
      </div>
      
      <div className="event-name">
        <h2>{eventName}</h2>
      </div>
      <hr className="divider" />
      
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>User Name</label>
              <input
                type="text"
                name="userName"
                value={formData.userName}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />
            </div>
            
            <div className="form-group">
              <label>Email ID</label>
              <input
                type="email"
                name="emailId"
                value={formData.emailId}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>How will you travel to the Event?</label>
              <select
                id="travelMode"
                name="travelMode"
                value={formData.travelMode}
                onChange={handleChange}
                required
              >
              <option value="">Select Travel Mode</option>
                {Object.keys(travelModeMapping).map((mode) => (
                  <option key={mode} value={mode}>
                    {mode}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Type of Transportation</label>
              <select
                id="transportationType"
                name="transportationType"
                value={formData.transportationType}
                onChange={handleChange}
                required
                disabled={!formData.transportationTypeOptions.length}
              >
                <option value="">Select Transportation Type</option>
                {formData.transportationTypeOptions.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Starting Location of your journey</label>
              <input
                 required
                 className="form-control"
                 id="location"
                 ref={locationRef}
                 placeholder="Enter location"
                 value={formData.startingLocation}
                 onChange={(e) =>
                   setFormData({
                     ...formData,
                     startingLocation: e.target.value,
                   })
                 }
              />
            </div>
            <div className="form-group">
              <label>Which type of hotel you will stay in?</label>
              <select
               id="hotelType"
                name="hotelType"
                value={formData.hotelType}
                onChange={handleChange}
                required
              >
                {Object.keys(hotelTypeMapping).map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Meal Preference</label>
              <select
                id="mealPreference"
                name="mealPreference"
                value={formData.mealPreference}
                onChange={handleChange}
                required
              >
                {Object.keys(mealPreferenceMapping).map((meal) => (
                  <option key={meal} value={meal}>
                    {meal}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Duration of the Event</label>
              <select
                 id="eventDuration"
                 name="eventDuration"
                 value={formData.eventDuration}
                 onChange={handleChange}
                 required
              >
                {Object.keys(eventDurationMapping).map((duration) => (
                  <option key={duration} value={duration}>
                    {duration}
                  </option>
                ))}
           
              </select>
            </div>
          </div>

          <div>
            <button type="submit" className="submit-button">
              Save
            </button>
          </div>
        </form>
      </div>
      {showAlert && (
          <CustomAlert
            message={alertMessage}
            type={alertType}
            onClose={handleCloseAlert}
          />
        )}
    </div>
  );
}

export default AddInformation;
